class Dropdown {

    constructor(container) {
        this.container = container
        this.trigger   = this.container.querySelector('.dropdown-trigger')
        this.inner     = this.container.querySelector('.dropdown-value')
        this.group     = this.container.querySelector('.dropdown-group')
        this.input     = this.container.querySelector('.dropdown-input')
        this.current   = this.group.querySelector('.dropdown-item.trigger')
    }

    init() {
        this.container.addEventListener('click', this.handleClick.bind(this))
        this.container.addEventListener('mouseenter', this.open.bind(this))
        this.container.addEventListener('mouseleave', this.close.bind(this))
    }

    handleClick(e) {
        let el = e.target

        if (el.classList.contains('dropdown-trigger') && !window.matchMedia('(hover:hover)').matches)
            return this.toggle(el)

        if (el.classList.contains('dropdown-item'))
            return this.select(el)
    }

    toggle(el) {
        el.classList.toggle('trigger')
        el.nextElementSibling.classList.toggle('trigger')
    }

    open() {

        if (!window.matchMedia('(hover:hover)').matches) return 
        
        this.trigger.classList.add('trigger')
        this.group.classList.add('trigger')
    }

    close() {

        if (!window.matchMedia('(hover:hover)').matches) return 
        
        this.trigger.classList.remove('trigger')
        this.group.classList.remove('trigger')
    }

    select(el) {

        if (!el.hasAttribute('data-dropdown-value')) return console.log('Error : data-dropdown-value is missing…')
        
        this.inner.innerHTML = el.innerHTML
        this.input.value = el.getAttribute('data-dropdown-value')
        this.trigger.classList.remove('trigger')
        this.group.classList.remove('trigger')

        this.current.classList.remove('trigger')
        this.current = el
        this.current.classList.add('trigger')
    }
}

export {Dropdown}